
export const FETCH_BILL_RECEIVING_VERIFY_DATA_REQUEST = 'FETCH_BILL_RECEIVING_VERIFY_DATA_REQUEST';
export const FETCH_BILL_RECEIVING_VERIFY_DATA_SUCCESS = 'FETCH_BILL_RECEIVING_VERIFY_DATA_SUCCESS';
export const FETCH_BILL_RECEIVING_VERIFY_DATA_FAILURE = 'FETCH_BILL_RECEIVING_VERIFY_DATA_FAILURE';

export const FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_REQUEST = 'FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_REQUEST';
export const FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_SUCCESS = 'FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_SUCCESS';
export const FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_FAILURE = 'FETCH_BILL_RECEIVING_VERIFIED_BRN_DATA_FAILURE';


export const VERIFY_BILL_RECEIVING_VERIFY_DATA_REQUEST = 'VERIFY_BILL_RECEIVING_VERIFY_DATA_REQUEST';
export const VERIFY_BILL_RECEIVING_VERIFY_DATA_SUCCESS = 'VERIFY_BILL_RECEIVING_VERIFY_DATA_SUCCESS';
export const VERIFY_BILL_RECEIVING_VERIFY_DATA_FAILURE = 'VERIFY_BILL_RECEIVING_VERIFY_DATA_FAILURE';

export const CREATE_USERFORM_BILL_RECEIVING_VERIFY = 'CREATE_USERFORM_BILL_RECEIVING_VERIFY';

export const VERIFY_BILL_RECEIVING_CALL_OFF_DATA_REQUEST = 'VERIFY_BILL_RECEIVING_CALL_OFF_DATA_REQUEST';
export const VERIFY_BILL_RECEIVING_CALL_OFF_DATA_SUCCESS = 'VERIFY_BILL_RECEIVING_CALL_OFF_DATA_SUCCESS';
export const VERIFY_BILL_RECEIVING_CALL_OFF_DATA_FAILURE = 'VERIFY_BILL_RECEIVING_CALL_OFF_DATA_FAILURE';